import React from 'react';
import Card from '@material-ui/core/Card';
import "./StandardCard.scss"
import CardContent from "@material-ui/core/CardContent";

interface IStandardCardProps {
  title: string,
  children: JSX.Element,
}

/**
 * Reusable info card component with custom styling
 * @param children
 * @constructor
 */
const StandardCard = ({title, children}: IStandardCardProps) => (
  <Card className="nzpost-js-tools-standard-card">
    <CardContent className="nzpost-js-tools-standard-card-content">
      <h3 className="nzpost-js-tools-standard-card-content-title">{title}</h3>
      <div className="nzpost-js-tools-standard-card-content-body">{children}</div>
    </CardContent>
  </Card>
);

export default StandardCard;


// WEBPACK FOOTER //
// ./src/components/lib/StandardCard/StandardCard.tsx